export const defaultLocale = process.env.REACT_APP_DEFAULT_LOCALE || 'en'

export const locales = {
  fa: 'fa',
  en: 'en',
  ko: 'ko',
}
